/* @flow */

import {colors} from '../../colors';

import type {ButtonVariant} from './icon-only-button';

export const getIconColor = (isDisabled: boolean, isActive: boolean, variant: ButtonVariant) => {
    if (isDisabled) {
        return colors.greyLt;
    }

    if (isActive) {
        if (variant === 'orange') {
            return colors.orange;
        }

        // For other variants, use default grey
        return colors.grey;
    }

    return colors.greyLt;
};
